(function() {
  ("use strict");

  // Configuration
  const CONFIG = {
    MIN_BULK_QUANTITY: 50,
    CHECK_INTERVAL: 1000, // Check every 1 second
    REMOVAL_DELAY: 500, // Wait 500ms before removing items
    BULK_KEYWORDS: [
      "Bulk and Custom Branded Lip Balm",
      "Custom Label Tattoo Balm Sticks",
      "Bulk and Custom SPF Lip Balm",
    ],
    OPTIONAL_EXTRAS: [
      "Custom Label Set Up Fee",
      "Custom Label Set Up Fee - SPF",
      "Custom Label Re-Order Fee",
      "Jump to the front of the line!",
    ],
  };

  // State tracking
  let isProcessing = false;
  let lastCartState = "";
  let removalTimeout = null;
  let checkInterval = null;

  // Utility functions
  function log(message, data = null) {
    console.log(`[Bulk Cart Logic] ${message}`, data || "");
  }

  function getCartItems() {
    // Try multiple selectors to find cart items
    let cartItems = document.querySelectorAll("[data-cart-item]");
    if (cartItems.length === 0) {
      cartItems = document.querySelectorAll(".t4s-mini_cart__item, .t4s-page_cart__item");
    }

    // If still no items, try looking inside cart containers
    if (cartItems.length === 0) {
      const cartContainers = document.querySelectorAll("[data-cart-items]");

      cartContainers.forEach((container) => {
        const items = container.querySelectorAll(
          "[data-cart-item], .t4s-mini_cart__item, .t4s-page_cart__item"
        );
        if (items.length > 0) {
          cartItems = items;
        }
      });
    }

    return Array.from(cartItems).map((item) => {
      const key = item.getAttribute("data-id") || item.getAttribute("data-item-key");
      const titleElement =
        item.querySelector("[data-item-title]") ||
        item.querySelector(".t4s-mini_cart__title") ||
        item.querySelector(".t4s-page_cart__title");
      const title = titleElement?.textContent?.trim() || "";
      const quantityElement = item.querySelector("[data-quantity-value]");
      const quantity = parseInt(quantityElement?.value || "0");
      const parentProductId = item.getAttribute("data-parent-product-id");
      const extraProductId = item.getAttribute("data-extra-product-id");
      const productId = item.getAttribute("data-pid");
      const extraProductType = item.getAttribute("data-extra-product-type");
      const extraAdditionalVariantId = item.getAttribute("data-extra-additional-variant-id");
      const subscriptionId = item.getAttribute("data-subscription-id")
      const totalFlavors = item.getAttribute("data-total-flavors");
      const result = {
        element: item,
        productId: productId,
        key: key,
        title: title,
        quantity: quantity,
        isBulk: isBulkProduct(title),
        isOptional: isOptionalExtra(title),
        parentProductId: parentProductId,
        extraProductId: extraProductId ? JSON.parse(extraProductId) : [],
        extraProductType: extraProductType,
        extraAdditionalVariantId: extraAdditionalVariantId,
        subscriptionId: subscriptionId,
        totalFlavors: totalFlavors
      };

      return result;
    });
  }

  function isBulkProduct(title) {
    if (!title) return false;
    const isBulk = CONFIG.BULK_KEYWORDS.includes(title);

    return isBulk;
  }

  function isOptionalExtra(title) {
    if (!title) return false;
    const isOptional = CONFIG.OPTIONAL_EXTRAS.includes(title);

    return isOptional;
  }

  function getTotalBulkQuantity() {
    const cartItems = getCartItems();
    const total = cartItems
      .filter((item) => item.isBulk)
      .reduce((total, item) => total + item.quantity, 0);

    return total;
  }

  function hasBulkProducts() {
    const cartItems = getCartItems();
    const hasBulk = cartItems.some((item) => item.isBulk);

    return hasBulk;
  }

  function getCartState() {
    const cartItems = getCartItems();
    const state = cartItems
      .map((item) => `${item.key}:${item.quantity}`)
      .join("|");

    return state;
  }

  // Cart manipulation functions
  function showLoadingForItem(itemKey) {
    // Find the cart item element
    const cartItem = document.querySelector(`[data-cart-item][data-id="${itemKey}"]`) || document.querySelector(`[data-cart-item][data-item-key="${itemKey}"]`);

    if (cartItem) {
      cartItem.classList.add("is--update");

      // Find and show loading bar
      const loadingBar = cartItem.querySelector(".t4s-cart-ld__bar");
      const spinner = cartItem.querySelector(".t4s-cart-spinner");

      if (loadingBar) {
        loadingBar.removeAttribute("hidden");
        loadingBar.style.display = "block";
      }

      if (spinner) {
        spinner.removeAttribute("hidden");
        spinner.style.display = "block";
      }

      // Add loading class to cart wrapper
      const cartWrapper = cartItem.closest("[data-cart-wrapper]") || cartItem.closest("[data-cart-items]") || document.querySelector("#t4s-mini_cart") || document.querySelector(".t4s-main-cart");

      if (cartWrapper) {
        cartWrapper.classList.add("is--contentUpdate");
      }

    }
  }

  function hideLoadingForItem(itemKey) {
    // Find the cart item element
    const cartItem = document.querySelector(`[data-cart-item][data-id="${itemKey}"]`) || document.querySelector(`[data-cart-item][data-item-key="${itemKey}"]`);

    if (cartItem) {
      cartItem.classList.remove("is--update");

      // Find and hide loading bar
      const loadingBar = cartItem.querySelector(".t4s-cart-ld__bar");
      const spinner = cartItem.querySelector(".t4s-cart-spinner");
      const check = cartItem.querySelector(".t4s-cart-check");

      if (loadingBar) {
        loadingBar.setAttribute("hidden", "");
        loadingBar.style.display = "none";
      }

      if (spinner) {
        spinner.setAttribute("hidden", "");
        spinner.style.display = "none";
      }

      if (check) {
        check.setAttribute("hidden", "");
        check.style.display = "none";
      }

      // Remove loading class from cart wrapper
      const cartWrapper = cartItem.closest("[data-cart-wrapper]") || cartItem.closest("[data-cart-items]") || document.querySelector("#t4s-mini_cart") || document.querySelector(".t4s-main-cart");

      if (cartWrapper) {
        cartWrapper.classList.remove("is--contentUpdate");
      }
    }
  }

  function showLoadingForItems(itemKeys) {
    itemKeys.forEach((key) => showLoadingForItem(key));
  }

  function hideLoadingForItems(itemKeys) {
    itemKeys.forEach((key) => hideLoadingForItem(key));
  }

  function UpdateItemQty(itemKey, qty) {
    return new Promise((resolve, reject) => {
      showLoadingForItem(itemKey);

      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: qty,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          hideLoadingForItem(itemKey);
          resolve(data);
        })
        .catch((error) => {
          hideLoadingForItem(itemKey);
          reject(error);
        });
    });
  }

  function AddAdditionalItem(parentProductId, extraAdditionalVariantId, qty) {
    return new Promise((resolve, reject) => {
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [{ 
            id: extraAdditionalVariantId, 
            quantity: qty,
            properties: {
              "_extra_product_type": "additional",
              "_extra_additional_variant_id": extraAdditionalVariantId,
              "_parent_product_id": parentProductId,
            }
          }],
        }),
      });
    });
  }

  function removeItem(itemKey) {
    return new Promise((resolve, reject) => {
      showLoadingForItem(itemKey);

      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          hideLoadingForItem(itemKey);
          resolve(data);
        })
        .catch((error) => {
          hideLoadingForItem(itemKey);
          reject(error);
        });
    });
  }

  function refreshCartDrawer() {
    return new Promise((resolve) => {
      if (window.t4s && window.t4s.cart && window.t4s.cart.updateDrawer) {
        try {
          window.t4s.cart.updateDrawer();
          setTimeout(() => {
            updateCartCountState();
            resolve();
          }, 200);
          return;
        } catch (error) {
          log("Theme updateDrawer failed, trying fetch", error);
        }
      }

      // Fallback to fetching cart section
      if (window.T4SThemeSP && window.T4SThemeSP.getToFetchSection) {
        window.T4SThemeSP.getToFetchSection("?section_id=mini_cart")
          .then((response) => {
            if (response && response !== "NVT_94") {
              const cartDrawer = document.querySelector("#t4s-mini_cart");
              if (cartDrawer) {
                cartDrawer.innerHTML = response;
              }
            }
            setTimeout(() => {
              updateCartCountState();
              resolve();
            }, 200);
          })
          .catch(() => {
            setTimeout(() => {
              updateCartCountState();
              resolve();
            }, 200);
          });
      } else {
        setTimeout(() => {
          updateCartCountState();
          resolve();
        }, 200);
      }
    });
  }

  function getFileExtension(url) {
    // Get the part of the URL before any query parameters or fragments
    const path = url.split('?')[0].split('#')[0];
    // Find the last dot in the path
    const lastDot = path.lastIndexOf('.');
    if (lastDot === -1) {
      return '';
    }
    // Return the substring after the last dot
    return path.substring(lastDot + 1);
  }

  function getFileName(url) {
    try {
      // Create a new URL object from the URL string
      const urlObject = new URL(url);
      
      // Get the pathname and split it by the '/' delimiter
      const pathSegments = urlObject.pathname.split('/');
      
      // The last segment of the path should be the file name
      return pathSegments.pop();
    } catch (error) {
      console.error('Invalid URL:', error);
      return null;
    }
  }

  async function printPreview() {
    const targetPreviews = document.querySelectorAll('.cart-file-wrapper');
    if (targetPreviews.length === 0) return;

    targetPreviews.forEach(async (targetPreview) => {
      const isRendered = targetPreview.getAttribute('data-rendered');
      const fileURL = targetPreview.getAttribute('data-file-url');
      if (isRendered === 'true' || !fileURL) return;
      const extension = getFileExtension(fileURL);
      const fileName = getFileName(fileURL);
      if(extension === "pdf" || extension === "ai") {
        printPDF(targetPreview, fileURL, fileName);
      } else if(extension === "png" || extension === "jpeg" || extension === "jpg") {
        printImage(targetPreview, fileURL, fileName);
      } else if(extension === "psd") {
        printPSD(targetPreview, fileURL, fileName, null, "preview");
      } else {
        printError(targetPreview, fileName);
      }
    })
  }

async function printPDF(targetPreview, fileURL, fileName) {
    try {
      const canvas = document.createElement('canvas');
      pdfjsLib.GlobalWorkerOptions.workerSrc = window?.workerUrl;
      const loadingTask = pdfjsLib.getDocument(fileURL);
      const pdf = await loadingTask.promise;
      const pageNumber = 1; // Or any desired page number
      const page = await pdf.getPage(pageNumber);
      const desiredWidth = 50
      const desiredHeight = 50
      const unscaledViewport = page.getViewport({ scale: 1.0 });
      const scaleX = desiredWidth / unscaledViewport.width;
      const scaleY = desiredHeight / unscaledViewport.height;
      const scale = Math.min(scaleX, scaleY); // Adjust scale as needed
      const viewport = page.getViewport({ scale });
      const context = canvas.getContext('2d');
      canvas.height = desiredHeight;
      canvas.width = desiredWidth;
      const renderContext = {
          canvasContext: context,
          viewport: viewport
      };
      const renderTask = page.render(renderContext);
      await renderTask.promise;
      targetPreview.innerHTML = '';
      targetPreview.appendChild(canvas);
      canvas.style.display = 'inline-block';
    } catch (error) {
      console.error("error print pdf or ai", error);
      const errorPreviewElm = document.createElement('div');
      const errorPreviewElmImg = document.createElement('img');
      const errorPreviewElmText = document.createElement('span');
      errorPreviewElmImg.src = 'https://cdn.shopify.com/s/files/1/0286/0941/3259/files/image-broken.svg?v=1759893789';
      errorPreviewElmText.textContent = fileName;
      errorPreviewElm.appendChild(errorPreviewElmImg);
      errorPreviewElm.appendChild(errorPreviewElmText);
      targetPreview.innerHTML = '';
      targetPreview.appendChild(errorPreviewElm);
    }
}

async function printImage(targetPreview, fileURL) {
  if (!targetPreview) return;
  const imageElement = document.createElement('img');
  imageElement.src = fileURL;
  imageElement.style.width = '50px';
  imageElement.style.display = 'block';
  targetPreview.innerHTML = '';
  targetPreview.appendChild(imageElement);
}

async function printError(targetPreview, fileName) {
  const errorPreviewElm = document.createElement('div');
  const errorPreviewElmImg = document.createElement('img');
  const errorPreviewElmText = document.createElement('span');
  errorPreviewElmImg.src = 'https://cdn.shopify.com/s/files/1/0286/0941/3259/files/image-broken.svg?v=1759893789';
  errorPreviewElmText.textContent = fileName;
  errorPreviewElm.appendChild(errorPreviewElmImg);
  errorPreviewElm.appendChild(errorPreviewElmText);
  targetPreview.innerHTML = '';
  targetPreview.appendChild(errorPreviewElm);
}

async function printPSD(targetPreview, fileURL, fileName, base64Image, previewType) {
    const previewElm = document.createElement('div');
    previewElm.classList.add("cart-file-preview");
    const previewElmImg = document.createElement('img');
    const previewElmText = document.createElement('span');
    if(base64Image) {
      previewElmImg.src = "data:image/png;base64," + base64Image;
      previewElm.appendChild(previewElmImg);
    } else {
      if(previewType === "upload") {
        previewElmImg.src = 'https://cdn.shopify.com/s/files/1/0286/0941/3259/files/image-broken.svg?v=1759893789';
        previewElmText.textContent = fileName;
        previewElm.appendChild(previewElmImg);
        previewElm.appendChild(previewElmText);
      } else {
        const response = await fetch("https://cqxj5vuftwa2hvmiqrjvzvkgke0waqee.lambda-url.us-east-1.on.aws/psd-convert", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-token": "YkFyb2thaDEzPw=="
          },
          body: JSON.stringify({ fileUrl: fileURL }),
        });
        const data = await response.json();
        if(response && data.base64) {
          previewElmImg.src = "data:image/png;base64," + data.base64;
          previewElm.appendChild(previewElmImg);
        } else {
          previewElmImg.src = 'https://cdn.shopify.com/s/files/1/0286/0941/3259/files/image-broken.svg?v=1759893789';
          previewElm.appendChild(previewElmImg);
          previewElmText.textContent = fileName;
          previewElm.appendChild(previewElmText);
        }
      }
    }
    targetPreview.innerHTML = '';
    targetPreview.appendChild(previewElm);
}

  function updateCartCountState() {
    // Get current cart items
    const cartItems = getCartItems();
    const totalItems = cartItems.reduce(
      (total, item) => total + item.quantity,
      0
    );

    // Update HTML element class based on cart count
    if (totalItems === 0) {
      document.documentElement.classList.add("t4s-cart-count-0");
    } else {
      document.documentElement.classList.remove("t4s-cart-count-0");
    }

    // Update cart count elements
    const cartCountElements = document.querySelectorAll("[data-cart-count]");
    cartCountElements.forEach((element) => {
      element.textContent = totalItems.toString();
    });

    // Update cart totals text
    const cartTotalElements = document.querySelectorAll("[data-cart-tt-price]");
    cartTotalElements.forEach((element) => {
      element.textContent = `${totalItems} items`;
    });

    // Update cart totals visibility
    const cartTotalsElements = document.querySelectorAll(".t4s-h-cart-totals");
    cartTotalsElements.forEach((element) => {
      if (totalItems === 0) {
        element.classList.add("t4s-dn");
      } else {
        element.classList.remove("t4s-dn");
      }
    });

    // Update cart divider visibility
    const cartDividerElements = document.querySelectorAll(".t4s-h-cart__divider");
    cartDividerElements.forEach((element) => {
      if (totalItems === 0) {
        element.classList.add("t4s-dn");
      } else {
        element.classList.remove("t4s-dn");
      }
    });
  }

  // Update cart totals in header
  function updateCartTotals() {
    updateCartCountState();
  }

  // Aggressive cart cleanup function
  async function aggressiveCartCleanup() {
    try {
      // Get current cart state
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const bulkItems = cart.items.filter(item =>
        CONFIG.BULK_KEYWORDS.some(keyword => item.product_title.toLowerCase().includes(keyword))
      );

      const optionalItems = cart.items.filter(item =>
        CONFIG.OPTIONAL_EXTRAS.includes(item.title)
      );

      const totalBulkQuantity = bulkItems.reduce((total, item) => total + item.quantity, 0);

      let needsUpdate = false;
      const updates = {};
      const itemsToShowLoading = [];

      // Remove all bulk items if quantity is below minimum
      if (bulkItems.length > 0 && totalBulkQuantity < CONFIG.MIN_BULK_QUANTITY) {
        bulkItems.forEach(item => {
          updates[item.key] = 0;
          itemsToShowLoading.push(item.key);
        });
        needsUpdate = true;
      }

      // Remove optional extras if no bulk items
      if (bulkItems.length === 0 && optionalItems.length > 0) {
        optionalItems.forEach(item => {
          updates[item.key] = 0;
          itemsToShowLoading.push(item.key);
        });
        needsUpdate = true;
      }

      if (needsUpdate) {
        // Show loading for all items being removed
        showLoadingForItems(itemsToShowLoading);

        const updateResponse = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates })
        });

        const updatedCart = await updateResponse.json();

        // Hide loading for all items
        hideLoadingForItems(itemsToShowLoading);

        // Update cart totals if cart is now empty
        if (updatedCart.item_count === 0) {
          updateCartTotals();
        }

        // Force page refresh to ensure cart drawer shows correct state
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }

    } catch (error) {
      log('Error in aggressive cart cleanup', error);
    }
  }

  // Main validation and cleanup function
  async function validateAndCleanCart() {
    if (isProcessing) {
      return;
    }

    const currentState = getCartState();
    if (currentState === lastCartState) { 
      return;
    }

    isProcessing = true;
    try {
      const cartItems = getCartItems();
      console.log("cartItems ====>", cartItems);
      const extraProducts = cartItems.filter((item) => item.parentProductId !== ""); // extra product is that item that has parent product id
      console.log("extraProducts ====>", extraProducts);
      for (const item of extraProducts) { 
        const extraParentProductId = item.key.split(":")[0];  
        console.log("item ====>", item);
        const isExtraOnSubscription = item.subscriptionId ? true : false;
        console.log("isExtraOnSubscription ====>", isExtraOnSubscription);
        const parentProduct = cartItems.filter((parent) =>
          parent.extraProductId.some((id) => {
            const isParentOnSubscription = parent.subscriptionId ? true : false;
            const sameId = id === extraParentProductId
            const sameSuscription = (isExtraOnSubscription && isParentOnSubscription) || 
                                    (!isExtraOnSubscription && !isParentOnSubscription)
            return sameId && sameSuscription
          })
        ); 
        console.log("1 =====>")
        console.log("parentProduct ====>", parentProduct);
        let totalFlavors = 0;
        if(parentProduct.length > 0) {
          parentProduct.forEach((product) => {
            totalFlavors += parseInt(product.totalFlavors);
          });
        }
        console.log("2 =====>")
        console.log("totalFlavors ====>", totalFlavors);
        if(item.extraProductType === "default") {
          if(totalFlavors < 1) {
            await removeItem(item.key);
          } 
          if(isExtraOnSubscription) {
            const priceElm = item.element.querySelector('.t4s-cart_meta_price');
            if(priceElm) {
              const priceDescription = document.createElement('div');
              priceDescription.classList.add('extra-item-price-description-2');
              priceDescription.textContent = `$15 per flavor for next order`;
              priceElm.appendChild(priceDescription);
            }
          }
          // else if(parentProduct.length > 1) {
          //   console.log("Adding additional item", item.extraAdditionalVariantId, parentProduct.length - 1);
          //   if(item.extraAdditionalVariantId) {
          //     await AddAdditionalItem(item.parentProductId, item.extraAdditionalVariantId, parentProduct.length - 1);
          //   }
          // }
        } else if(item.extraProductType === "additional") {
          if(isExtraOnSubscription) {
            const priceElm = item.element.querySelector('.t4s-cart_meta_price');
            const priceElmDesc = item.element.querySelector('.extra-item-price-description');
            if(!priceElmDesc) {
              const priceDescription = document.createElement('div');
              priceDescription.classList.add('extra-item-price-description');
              priceDescription.textContent = `$15 per flavor for next order`;
              priceElm.appendChild(priceDescription);
            } else {
              priceElmDesc.textContent = `$15 per flavor for next order`;
            }
          }
          console.log("4 =====>")
          if(totalFlavors < 2) {
            await removeItem(item.key);
            console.log("5 =====>")
          } else {
            if((totalFlavors - 1) !== item.quantity) {
              await UpdateItemQty(item.key, totalFlavors - 1);
            };
          }
        } else if(item.extraProductType === "each") {
          if(totalFlavors < 1) {
            await removeItem(item.key);
          } else {
            if((totalFlavors - 1) !== item.quantity) {
              await UpdateItemQty(item.key, totalFlavors - 1);
            };
          }
        }
        console.log("3 =====>")
      };
      await refreshCartDrawer();
      lastCartState = currentState;
    } catch (error) {
      log("Error in cart validation", error);
    } finally {
      printPreview();
      isProcessing = false;
    }

  }

  // Event listeners
  function setupEventListeners() {
    // Listen for quantity changes
    document.addEventListener("change", function (e) {
      if (e.target.matches("[data-quantity-value]")) {
        setTimeout(validateAndCleanCart, 100);
      }
    });

    // Listen for quantity selector clicks
    document.addEventListener("click", function (e) {
      if (e.target.matches("[data-quantity-selector]")) {
        setTimeout(validateAndCleanCart, 100);
      }
    });

    // Listen for cart updates
    document.addEventListener("cart:updated", function () {
      setTimeout(validateAndCleanCart, 200);
      setTimeout(updateCartCountState, 300);
    });

    // Listen for cart changes
    document.addEventListener("cart:change", function () {
      setTimeout(validateAndCleanCart, 200);
      setTimeout(updateCartCountState, 300);
    });

    // Listen for drawer opens
    document.addEventListener("drawer:open", function (e) {
      if (e.detail && e.detail.drawer === "cart") {
        setTimeout(validateAndCleanCart, 300);
      }
    });

    // Listen for page visibility changes
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) {
        setTimeout(validateAndCleanCart, 500);
      }
    });

    // Listen for focus events
    window.addEventListener("focus", function () {
      setTimeout(validateAndCleanCart, 500);
    });

    // Listen for DOM changes
    const observer = new MutationObserver(function (mutations) {
      let shouldCheck = false;

      mutations.forEach(function (mutation) {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
          for (let node of mutation.addedNodes) {
            if (node.nodeType === 1 && (node.matches("[data-cart-item]") || node.querySelector("[data-cart-item]") || node.matches(".t4s-mini_cart__item") || node.querySelector(".t4s-mini_cart__item"))) {
              shouldCheck = true;
              break;
            }
          }
        }
      });

      if (shouldCheck) {
        setTimeout(validateAndCleanCart, 200);
        setTimeout(updateCartCountState, 300); // Also update cart count state
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Monitor cart drawer visibility
    const cartDrawerObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === "attributes" && mutation.attributeName === "class") {
          const cartDrawer = document.querySelector("#t4s-mini_cart");
          if (cartDrawer && cartDrawer.classList.contains("is--open")) {
            setTimeout(validateAndCleanCart, 300);
          }
        }
      });
    });

    const cartDrawer = document.querySelector("#t4s-mini_cart");
    if (cartDrawer) {
      cartDrawerObserver.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  }

  // Unified cart removal function (global scope)
  function handleCartItemRemoval(itemKey, event) {
    if (!itemKey) {
      console.error('No item key provided for removal');
      return Promise.reject(new Error('No item key provided'));
    }

    // Prevent default behavior if event is provided
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // Show loading state
    showLoadingForItem(itemKey);

    // Remove the item and handle the entire flow
    return removeItem(itemKey)
      .then((cartData) => {
        // Refresh cart drawer
        return refreshCartDrawer().then(() => cartData);
      })
      .then((cartData) => {
        // Update cart count state
        updateCartCountState();

        // Trigger cart update events
        document.dispatchEvent(
          new CustomEvent("cart:updated", {
            detail: {
              count: cartData?.item_count || 0,
              cart: cartData,
              removedItemKey: itemKey
            },
            bubbles: true,
            cancelable: true,
          })
        );

        // Also trigger a specific remove event
        document.dispatchEvent(
          new CustomEvent("cart:item-removed", {
            detail: {
              itemKey: itemKey,
              cart: cartData,
              count: cartData?.item_count || 0
            },
            bubbles: true,
            cancelable: true,
          })
        );

        return cartData;
      })
      .catch((error) => {
        console.error('Error removing item from cart:', error);
        hideLoadingForItem(itemKey);

        // Show user-friendly error message
        const errorEvent = new CustomEvent("cart:error", {
          detail: {
            error: error,
            action: 'remove',
            itemKey: itemKey
          },
          bubbles: true,
          cancelable: true,
        });
        document.dispatchEvent(errorEvent);

        throw error;
      });
  }

  // Initialize the system
  function init() {
    // Add CSS for proper centering of loading elements
    addLoadingCenteringStyles();

    // Set up event listeners
    setupEventListeners();

    // Initial check
    setTimeout(validateAndCleanCart, 500);

    // Periodic checks
    if (checkInterval) {
      clearInterval(checkInterval);
    }

    // Force check when cart drawer opens
    const originalOpenDrawer = window.t4s?.cart?.openDrawer;
    if (originalOpenDrawer) {
      window.t4s.cart.openDrawer = function (...args) {
        setTimeout(validateAndCleanCart, 100);
        return originalOpenDrawer.apply(this, args);
      };
    }

    // Make function globally available for debugging
    window.bulkCartLogic = {
      validateAndCleanCart,
      getCartItems,
      getTotalBulkQuantity,
      hasBulkProducts,
      aggressiveCartCleanup,
      showLoadingForItem,
      hideLoadingForItem,
      showLoadingForItems,
      hideLoadingForItems,
      removeItem,
      refreshCartDrawer,
      updateCartTotals,
      updateCartCountState,
      handleCartItemRemoval,
      CONFIG,
    };

    // Add manual trigger function
    window.forceBulkCartValidation = function () {
      validateAndCleanCart();
    };

    // Add function to force update cart count state
    window.forceUpdateCartCount = function () {
      updateCartCountState();
    };

    // Add function to handle initial add to cart
    window.handleInitialAddToCart = function () {
      setTimeout(updateCartCountState, 100);
      setTimeout(updateCartCountState, 500);
      setTimeout(updateCartCountState, 1000);
    };

    // Add cart remove functionality
    function initCartRemoveHandlers() {
      // Handle cart remove button clicks
      document.addEventListener('click', function(e) {
        const removeButton = e.target.closest('[data-cart-remove]');
        if (removeButton) {
          const itemKey = removeButton.getAttribute('data-id');
          handleCartItemRemoval(itemKey, e);
        }
      });

      // Handle quantity decrease to 0 (which removes the item) - backup handler
      document.addEventListener('click', function(e) {
        const decreaseButton = e.target.closest('[data-decrease-qty]');
        if (decreaseButton) {
          const quantityWrapper = decreaseButton.closest('[data-quantity-wrapper]');
          if (quantityWrapper) {
            const quantityInput = quantityWrapper.querySelector('[data-quantity-value]');
            if (quantityInput && parseInt(quantityInput.value) === 0) {
              const itemKey = quantityInput.getAttribute('data-id');
              if (itemKey) {
                handleCartItemRemoval(itemKey, e);
              }
            }
          }
        }
      });

      // Handle quantity input changes that result in 0 - backup handler
      document.addEventListener('change', function(e) {
        const quantityInput = e.target.closest('[data-quantity-value]');
        if (quantityInput && parseInt(quantityInput.value) === 0) {
          const itemKey = quantityInput.getAttribute('data-id');
          if (itemKey) {
            handleCartItemRemoval(itemKey, e);
          }
        }
      });
    }

    // Initialize cart remove handlers
    initCartRemoveHandlers();

    // Delegated handlers for cart tool actions — survives innerHTML replacement by refreshCartDrawer
    initCartToolHandlers();
  }

  function initCartToolHandlers() {
    document.addEventListener('click', function(e) {
      // Open tool panel
      const toolBtn = e.target.closest('[data-cart-tool_action]');
      if (toolBtn) {
        const toolId = toolBtn.getAttribute('data-id');
        const cartDrawer = document.querySelector('#t4s-mini_cart');
        if (cartDrawer && toolId) {
          // Close any other open panels first
          cartDrawer.querySelectorAll('.t4s-mini_cart-tool__content.is--opend').forEach(p => p.classList.remove('is--opend'));

          const panel = cartDrawer.querySelector('.t4s-mini_cart-tool__content.is--' + toolId);
          if (panel) {
            panel.classList.add('is--opend');
            const focusEl = panel.querySelector('[data-opend-focus]');
            if (focusEl) setTimeout(() => focusEl.focus(), 300);
          }
        }
      }

      // Close tool panel
      const closeBtn = e.target.closest('[data-cart-tool_close]');
      if (closeBtn) {
        const panel = closeBtn.closest('.t4s-mini_cart-tool__content');
        if (!panel) return;

        const isSaveBtn = closeBtn.classList.contains('t4s-mini_cart-tool__primary');

        // Save note — wait for the API to confirm before closing
        if (panel.classList.contains('is--note') && isSaveBtn) {
          const noteTextarea = panel.querySelector('textarea[name="note"]');
          if (noteTextarea) {
            closeBtn.disabled = true;
            closeBtn.textContent = 'Saving…';

            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ note: noteTextarea.value })
            })
              .then(res => res.json())
              .then((cart) => {
                const hasNote = (cart.note || '').trim().length > 0;
                const cartDrawer = document.querySelector('#t4s-mini_cart');
                if (cartDrawer) {
                  cartDrawer.querySelectorAll('.is--addNote').forEach(b => b.classList.toggle('t4s-d-none', hasNote));
                  cartDrawer.querySelectorAll('.is--editNote').forEach(b => b.classList.toggle('t4s-d-none', !hasNote));
                }
                panel.classList.remove('is--opend');
              })
              .catch(() => {
                panel.classList.remove('is--opend');
              })
              .finally(() => {
                closeBtn.disabled = false;
                closeBtn.textContent = 'Save';
              });

            return; // don't close panel yet — wait for fetch
          }
        }

        // Save discount code if applicable
        if (closeBtn.hasAttribute('data-action') && closeBtn.getAttribute('data-action') === 'save-discountcode') {
          const input = panel.querySelector('[data-name="discount"]');
          const hiddenInput = document.querySelector('[data-cart-discount]');
          if (input && hiddenInput) {
            hiddenInput.value = input.value;
          }
        }

        panel.classList.remove('is--opend');
      }
    });
  }

  // Add CSS styles for proper centering of loading elements
  function addLoadingCenteringStyles() {
    const style = document.createElement("style");
    style.textContent = `
      /* Ensure proper centering of loading elements for bulk cart logic - only in mini cart images */
      .t4s-mini_cart__img .t4s-cart-ld__bar {
        position: absolute !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        background: transparent !important;
        z-index: 10 !important;
        border-radius: 4px !important;
      }

      .t4s-mini_cart__img .t4s-cart-ld__bar:has(.t4s-cart-spinner:not([hidden])),
      .t4s-mini_cart__img .t4s-cart-ld__bar:has(.t4s-cart-check:not([hidden])) {
        background: rgba(255, 255, 255, 0.8) !important;
      }

      .t4s-mini_cart__img .t4s-cart-spinner,
      .t4s-mini_cart__img .t4s-cart-check {
        width: 20px !important;
        height: 20px !important;
        animation: spin 1s linear infinite !important;
      }

      .t4s-mini_cart__img .t4s-cart-check {
        animation: none !important;
        color: #28a745 !important;
      }

      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
